import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { ALL_MODELS, ALL_MODELS_RUNE } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { AllModalsDataActionTypes } from './types';
import modelsApi from 'src/utils/api/modelsApi';

export const loadAllModels =
  (
    params: string,
  ): ThunkAction<Promise<void>, State, null, AllModalsDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: ALL_MODELS + REQUEST });
    try {
      const payload = await modelsApi.loadAllModels(params);
      dispatch({ type: ALL_MODELS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: ALL_MODELS + FAILURE, error });
    }
  };

export const runModelsTime = (id: string) => ({
  type: ALL_MODELS_RUNE,
  payload: id,
});
